import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$org/$project/volumes/$name/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$org/$project/volumes/$name/$tab", params: { ...params, tab: "overview" } });
  },
});
